import React from 'react'

export default class IconsMainNavCompanySwitcher extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M10 12L6 8L10 4'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
